import React, { useState, useRef, useEffect } from 'react';
import { FooterModal } from "components/common/modal/Footer";
import { Body } from "components/common/modal/Body";
import { HeaderModal } from "components/common/modal/Header";

import allImgPaths from "assets/images";
import CustomSelect from 'components/common/CustomSelect';
import CustomCheckBox from 'components/CustomCheckBox';
import useAppState from 'context/useAppState';
import Select, { SingleValue } from "react-select";
import { addFileHistoryData, fileUploadExtraction, getEventTaskList } from 'services/event';
import { useParams } from 'react-router-dom';
import { llmCreateRAG } from 'services/llm';
import { formatFileSize } from 'utils/function';
import { customSelectStyle } from 'utils/style';
import { generatePresignedUrl, generatePresignedUrlForVendor, uploadFileToS3, uploadVendorFileToS3 } from 'services/auth/auth';
import { ALLOWED_FILE_MIME_TYPES, DOCUMENTS_BUCKET_NAME, DOCUMENT_ROUTE_PREFIX, MAX_FILE_SIZE } from 'utils/constant';
import { Modal } from 'components/common/modal/Modal';
import { getLLMAgentRAGCreatePayload } from 'services/llm/payloads';

type taskDropDown = {
    value: string;
    label: string;
};

const UploadVendorDocumentModel = ({ dataObj }: any) => {
    console.log({ dataObj })
    const { showUploadFileModal, setState: setChatBoxState } = useAppState('chatBox');
    const { selectedCardDetail } = useAppState('cardWrapper')
    const { draftEvent } = useAppState('newFeteChat')
    const actualBtnRef = useRef<any>(null);
    const params: any = useParams();
    const [fileList, setFileList] = useState<any>([]);
    const [dropDownOptions, setDropDownOptions] = useState<taskDropDown[]>([]);
    const [taskDropDownValue, setTaskDropDownValue] = useState<taskDropDown | null>();
    const [progressMap, setProgressMap] = useState<any>({});
    const [isRequesting, setIsRequesting] = useState(false);
    const { setState: setEventDataState, bestActionPrompt } = useAppState('eventData');

    const userData = JSON.parse(localStorage.getItem('userData') as string)
    const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)


    useEffect(() => {
        if (showUploadFileModal && selectedCardDetail) {
            const { columnId: block_id, id } = selectedCardDetail;

            (async () => {
                const { data } = await getEventTaskList(params?.id, block_id, id);

                const modifiedOptions = data[0].tasks.map((task: any) => ({
                    value: task._id,
                    label: task.title,
                }));

                // Add "Main" option
                modifiedOptions.unshift({ value: "main", label: "Main" });

                setDropDownOptions(modifiedOptions);
            })();
        }
    }, [showUploadFileModal]);

    const handleChange = (selectedFiles: FileList) => {
        const filesArray: any = Array.from(selectedFiles).filter((file: any) => file.size < MAX_FILE_SIZE && ALLOWED_FILE_MIME_TYPES.includes(file.type));
        const newFilesArr = [...fileList, ...filesArray]
        setFileList(newFilesArr);
        const initialProgressMap: any = {};
        newFilesArr?.forEach((file: any) => {
            initialProgressMap[file.name] = 0;
        });
        setProgressMap(initialProgressMap);
    }

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        handleChange(droppedFiles);
    }

    const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    }

    const onCloseModal = () => {
        setFileList([])
        setChatBoxState({ showUploadFileModal: false });
    }

    const handleDropDownChange = (selectedValue: SingleValue<taskDropDown>) => {
        if (selectedValue !== null) {
            setTaskDropDownValue(selectedValue);
        }
    };

    const resetStateToDefaults = () => {
        setChatBoxState({ showUploadFileModal: false });
        setProgressMap({});
        setFileList([]);
        setIsRequesting(false)
    }


    const getPresignedURL = async (file: any) => {
        try {
            const processingData = {
                // type: 'RFP',
                type: 'VenueVendorContract',
                actions: 'extraction_summarization'
            }
            const { data } = await generatePresignedUrlForVendor({
                file_name: file.name,
                content_type: file.type,
                category: "document",
                event_id: dataObj?.eventId || draftEvent?._id || params?.id,
                user_id: userData?.id,
                team_id: currentTeam?.currentTeamId,
                file_type: processingData.type,
                tagging: new URLSearchParams(processingData).toString(),
                rfp_categories: dataObj?.rfp_categories || [],
                vendor_id: dataObj?.vendorId || null
            });
            return data;
        } catch (error) {
            console.log('getPresigned URL err>>', error);
        }
    }

    const getMetadataForCreateRAGPayload = () => {
        const metadata_payload: any = {
            "userId": userData?.id,
            "teamId": currentTeam?.currentTeamId,
            "eventId": params?.id || draftEvent?._id,
        }
        if (params?.id) {
            metadata_payload['is_draft'] = false;
        } else {
            metadata_payload['is_draft'] = true;
        }
        if (selectedCardDetail) {
            // metadata_payload['blockId'] = selectedCardDetail?.block_id;
            metadata_payload['blockId'] = selectedCardDetail?.columnId || selectedCardDetail?.block_id;
            metadata_payload['cardId'] = selectedCardDetail?.id
        }
        return metadata_payload;
    }

    const initiateS3UploadWithPresignedURL = async (file: any, presigedURLObj: any) => {
        const response = await uploadVendorFileToS3({
            url: presigedURLObj.url,
            file: file,
            type: file.type,
            tagging: presigedURLObj.tagging
        });

        if (response.status === 200) {
            await llmCreateRAG(getLLMAgentRAGCreatePayload({
                file_path: `s3://${DOCUMENTS_BUCKET_NAME}/${DOCUMENT_ROUTE_PREFIX}/${presigedURLObj?.fileName}`,
                metadata: getMetadataForCreateRAGPayload(),
            }))

            // Add file upload history
            const historyPayload: any = {
                eventId: params?.id || draftEvent?._id,
                content: {
                    s3Filename: presigedURLObj?.fileName,
                    category: 'document',
                    file: {
                        lastModified: file.lastModified,
                        name: file.name,
                        size: file.size,
                        type: file.type
                    }
                }
            }
            if (taskDropDownValue?.value) historyPayload['taskId'] = taskDropDownValue.value;

            // await addFileHistoryData(historyPayload);

            // Reset task data, if selected
            setTaskDropDownValue(null)
        }
    }

    const uploadFile = async (file: any) => {
        try {
            // Simulate a delay (e.g., 5 seconds) for the request
            const delaySeconds = 5;
            const startTime = new Date().getTime();

            while (new Date().getTime() - startTime < delaySeconds * 1000) {
                const elapsedTime = new Date().getTime() - startTime;
                const calculatedProgress = Math.min(Math.floor((elapsedTime / (delaySeconds * 1000)) * 100), 100);
                // setProgress(calculatedProgress);
                setProgressMap((prevProgressMap: any) => ({
                    ...prevProgressMap,
                    [file.name]: calculatedProgress,
                }));
                await new Promise(resolve => setTimeout(resolve, 100)); // Update progress every 100 milliseconds
            }
            const presigedURLObj = await getPresignedURL(file)
            if (presigedURLObj) {
                await initiateS3UploadWithPresignedURL(file, presigedURLObj)
            }
        } catch (error) {
            console.log('UPLOAD FILE ERR>>', error);
        }
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsRequesting(true);
        const uploadPromises = fileList.map((file: any) => uploadFile(file));
        await Promise.all(uploadPromises);
        resetStateToDefaults()
    }

    const getProgressbar = (file: any) => {
        return (
            <>
                <span
                    className="bg-[#1E0AF5] h-2 rounded-full transform transition-all duration-1000"
                    style={{ width: progressMap[file.name] > 0 ? `${progressMap[file.name]}%` : '' }}
                ></span>
                <span className='font-interMedium text-sm text-[#344054]'>{progressMap[file.name] > 0 ? `${progressMap[file.name]}%` : ''}</span>
            </>
        )
    }

    const getDocumentIcon = (file: any) => {
        let icon;
        switch (file.type) {
            case 'application/pdf':
                icon = allImgPaths.fileTypePdfIcon
                break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                icon = allImgPaths.fileTypeDOCXIcon
                break;
            case 'text/csv':
                icon = allImgPaths.fileTypeCSVIcon
                break;
            case 'text/plain':
                icon = allImgPaths.fileTypeTXTIcon
                break;
            default:
                icon = allImgPaths.fileTypeXLSXIcon
                break;
        }
        return icon;
    }

    return (
        <>
            <Modal className={"modal-wrapper max-w-[480px]"} isShow={showUploadFileModal}>
                <form onSubmit={handleSubmit}>
                    <HeaderModal
                        title=""
                        isShowHeader={true}
                        className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex justify-center items-center gap-x-4">
                                <img className="top-0.5 left-0 object-contain -z-10" src={allImgPaths.uploadFileIcon} alt="" />
                                <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                                    Upload File
                                </h2>
                            </div>
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#F2F4F7] rounded w-5 p-1 -mt-6"
                                id="modal-toggle"
                                src={allImgPaths.closeIcon}
                                onClick={onCloseModal}
                                alt="close icon"
                            />
                        </div>
                    </HeaderModal>

                    <Body title="" isShowBody={true} className="modal-body px-6 pt-5">
                        <div className='' onDrop={handleDrop} onDragOver={onDragOver}>
                            <input
                                type="file"
                                id="actual-btn"
                                ref={actualBtnRef}
                                onChange={(e: any) => handleChange(e.target.files)}
                                hidden
                                accept=".pdf, .docx, .csv, .txt, .xls, .xlsx"
                                multiple
                            />
                            <label className='file-upload block border border-[#EAECF0] hover:border-[#786CF9] rounded-xl py-4 px-6 text-center mb-6 cursor-pointer' htmlFor="actual-btn">
                                <img className='mb-3 mx-auto' src={allImgPaths.uploadFileIcon3} alt="" />
                                <div className="">
                                    <span className='text-sm text-[#1E0AF5] font-interSemiBold'>Click to upload</span>
                                    <span className='text-sm text-[#475467]'> or drag and drop</span>
                                    <p className='text-sm text-[#475467]'>PDF, TXT, DOC or XLS (max. 10 MB)</p>
                                </div>
                            </label>

                            {fileList.length > 0 && (
                                <>
                                    {fileList.map((file: any, index: any) => (
                                        <div className="block border-2 border-[#EAECF0] rounded-xl py-3.5 px-3.5 cursor-pointer mb-5" key={index}>
                                            <div key={index} className="flex gap-x-3 items-start">
                                                <img src={getDocumentIcon(file)} alt="" />
                                                <div className="w-full">
                                                    <div className="w-full">
                                                        <p className='text-sm text-[#475467]'>{file.name}</p>
                                                    </div>
                                                    <p className='text-sm text-[#475467]'>{formatFileSize(file.size)}</p>
                                                    <div className="flex items-center gap-x-2">
                                                        {isRequesting && getProgressbar(file)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {selectedCardDetail && (
                                        <>
                                            <div className="relative w-full pt-1 mb-6">
                                                <p className="text-[#344054] text-sm font-interMedium pb-2">Apply to task</p>
                                                {dropDownOptions?.length > 0 ? (
                                                    <Select
                                                        value={taskDropDownValue}
                                                        onChange={handleDropDownChange}
                                                        options={dropDownOptions}
                                                        isSearchable={true}
                                                        placeholder="Select"
                                                        className="multi-select-wrapper placeholder:text-[#344054] placeholder:text-base text-base text-[#344054]"
                                                        // menuIsOpen={true}
                                                        classNamePrefix="select"
                                                        styles={customSelectStyle}
                                                    />
                                                ) : (
                                                    <p>Loading options...</p>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </Body>

                    <FooterModal title="" isShowFooter={true} className="modal-footer pt-4 px-6 pb-4 border-t border-[#EAECF0]">
                        <div className="flex items-center gap-x-3 justify-center">
                            <button onClick={onCloseModal} className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 hover:bg-[#f2f4f7]">Cancel</button>
                            <button
                                disabled={isRequesting || fileList?.length === 0}
                                type='submit'
                                className="!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 flex-1">Upload File</button>
                        </div>
                    </FooterModal>
                </form>
            </Modal>
        </>
    )
}

export default UploadVendorDocumentModel;
